import {
  addToaster,
  fetchCaptureApiResponse,
  hideLoader,
  intakeCdsRequest,
  interruptWorkFlow,
  showLoader,
  useDispatch,
  WorkflowInstanceTaskType,
} from '@app-store'
import {
  Accordion,
  CustomButton,
  CustomTable,
  Modal,
  NAMESPACE,
  // Pagination,
  SkeletonLoader,
  // SORT_KEYS,
  TableColumnType,
} from '@ui-kit'
import React, { useEffect, useState } from 'react'
import {
  CaptureApiResponseProps,
  CdsRequestApiBody,
} from '../../types/pap.types'
import { PAP_CONSTANTS, PAP_NAMESPACES } from '../../utils/pap.constants'
// import { convertToCamelCase } from '../../utils/helperFunctions'
import { isEmpty, uniqueId } from 'lodash'
// import { FIELD_VALUE_CONSTANTS } from '../../utils/constants'
import PapCaptureApiShowResponse from './PapCaptureApiShowResponse'
import { STRINGS } from '../../utils/strings'
import { WORKFLOW_STATUS } from '../../utils/constants'
import { useAppSelector } from '../../utils/agent.store'

const PapCaptureApiResponse: React.FC<{
  recordId?: string
  task: WorkflowInstanceTaskType
  reFetch: () => void
}> = ({ recordId, task, reFetch }) => {
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const [data, setData] = useState<CaptureApiResponseProps[]>([])
  const [modalParsedData, setModalParsedData] =
    useState<CaptureApiResponseProps | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  /* TODO: Need this later for pagination
  const [currentPage, setCurrentPage] = useState<number>(
    FIELD_VALUE_CONSTANTS?.ONE
  )
  const [totalPages, setTotalPages] = useState<number>(0)
  const firstRender = useRef(true)
  */
  const [showResponse, setShowResponse] = useState<boolean>(false)
  const dispatch = useDispatch()
  const columns: TableColumnType<CaptureApiResponseProps>[] = [
    {
      header: PAP_NAMESPACES?.INTEGRATION_NAME,
      accessor: PAP_CONSTANTS?.INTEGRATION_NAME,
      type: 'string',
      // isSortable: true,
    },
    {
      header: PAP_NAMESPACES?.STATUS,
      accessor: PAP_CONSTANTS?.STATUS,
      type: 'string',
      // isSortable: true,
    },
    {
      header: PAP_NAMESPACES?.MODIFIED_BY,
      accessor: PAP_CONSTANTS?.MODIFIED_BY,
      type: 'string',
      // isSortable: true,
    },
    {
      header: PAP_NAMESPACES?.CREATED_AT,
      accessor: PAP_CONSTANTS?.CREATED_AT,
      type: 'string',
      // isSortable: true,
    },
    {
      header: PAP_NAMESPACES?.RESPONSE,
      accessor: PAP_CONSTANTS?.RESPONSES,
      type: 'component',
      renderComponent: (row: CaptureApiResponseProps) => (
        <div className="font-light">
          <button
            className="text-blue-500 underline"
            onClick={() => handleShowResponse(row)}
            type={'button'}
          >
            {PAP_NAMESPACES?.VIEW_RESPONSE}
          </button>
        </div>
      ),
    },
  ]

  /* TODO: Need this later for pagination
  const [sortDirection, setSortDirection] = useState<{
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  }>({
    key: 'name',
    isAsc: SORT_KEYS.Asc,
    keyName: 'name',
    direction: SORT_KEYS.Asc,
  })
  */

  const handleCloseModal = () => {
    setShowResponse(false)
    setModalParsedData(null)
  }

  /* TODO: Need this later for pagination
  const onSortClick = (key: string, isAsc: SORT_KEYS) => {
    if (key) {
      const newKeyName = convertToCamelCase(key)
      setSortDirection({
        keyName: isAsc === SORT_KEYS.Disabled ? '' : newKeyName,
        direction: isAsc,
        key: isAsc === SORT_KEYS.Disabled ? '' : key,
        isAsc: isAsc,
      })
    }
  }
  */

  /* TODO: Need this later for pagination
  const handlePageChange = async (_page: number, _rowPerPage: number) => {
    if (firstRender?.current) {
      firstRender.current = false
      return
    }
    fetchData()
    // TODO: Update logic to accept page number and row per page
    setCurrentPage(1)
  }
  */

  const fetchData = async () => {
    try {
      const response = await fetchCaptureApiResponse(task?.identifier?.task_id)
      const finalData =
        response?.data?.content?.map((item: CaptureApiResponseProps) => ({
          ...item,
          attempt_count: item?.attempt_count?.toString(),
        })) || []
      const transformedData = finalData?.flatMap(
        (item: CaptureApiResponseProps) => {
          if (
            Number(item?.attempt_count) > 0 &&
            Array?.isArray(item?.responses)
          ) {
            return item?.responses
              ?.slice(0, Number(item?.attempt_count))
              ?.map((response, index) => {
                const apiResult = response?.result
                const timeStamp = apiResult?.error
                  ? apiResult?.error?.timestamp
                  : apiResult?.result?.timestamp ?? item?.created_at
                return {
                  ...item,
                  status: apiResult?.error
                    ? NAMESPACE.FAILED
                    : NAMESPACE.DELIVERED,
                  attempt_number: index + 1,
                  created_at: timeStamp
                    ? new Date(timeStamp)
                        ?.toISOString()
                        ?.slice(0, 19)
                        ?.replace('T', ' ')
                    : null,
                  responses: [response],
                }
              })
          }

          return [
            {
              ...item,
            },
          ]
        }
      )
      setData(transformedData)
    } catch (err) {
      console.error(err)
      dispatch(
        addToaster({
          message: STRINGS.SOMETHING_WENT_WRONG,
          type: 'error',
          id: uniqueId(),
        })
      )
    } finally {
      setLoading(true)
    }
  }
  const handleShowResponse = async (row: CaptureApiResponseProps) => {
    setModalParsedData(row ?? [])
    setShowResponse(true)
  }
  const manualCdsRequest = async () => {
    try {
      dispatch(showLoader())
      const payload: CdsRequestApiBody = {
        document_id: task?.identifier?.document_id ?? '',
        case_id: recordId ?? '',
        task_id: task?.identifier?.task_id ?? '',
        mode: 'sync',
      }
      await intakeCdsRequest(payload)
    } catch (err) {
      console.error(err)
    } finally {
      await fetchData()
      dispatch(hideLoader())
    }
  }
  const interruptAutoCDS = async () => {
    try {
      await interruptWorkFlow({
        workflowId: workflowInstance?.id ?? '',
        signal: task?.identifier?.signal ?? '',
      })
      reFetch()
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (task) {
      fetchData()
    }
  }, [task])

  useEffect(() => {
    const isDelivered = data?.filter(
      (item) => item?.status === NAMESPACE.DELIVERED
    )?.length
    if (isDelivered && task?.state === WORKFLOW_STATUS.OPEN) {
      interruptAutoCDS()
    }
  }, [data])

  return (
    <>
      <div className="flex px-2 pt-2 pb-1">
        <div className="ml-auto">
          <CustomButton
            onClick={() => manualCdsRequest()}
            isFilled
            disabled={
              !isEmpty(
                data?.filter((item) => item?.status === NAMESPACE.DELIVERED)
              ) || task?.state !== WORKFLOW_STATUS.OPEN
            }
          >
            <span>{NAMESPACE.INTAKE_CDS_REQUEST}</span>
          </CustomButton>
        </div>
      </div>

      {loading ? (
        <Accordion
          alwaysOpen={true}
          heading={<div>{PAP_NAMESPACES?.CAPTURE_API_RESPONSE}</div>}
        >
          <div className="p-2">
            <CustomTable
              columns={columns}
              data={data}
              emptyDataMessage={PAP_NAMESPACES?.NO_DATA}
              showTableColumnOnEmpty={true}
              /* TODO: Need this later for pagination
              sort={
                sortDirection.key && !isEmpty(sortDirection?.key)
                  ? { key: sortDirection?.key, isAsc: sortDirection?.isAsc }
                  : null
              }
              onSortClick={onSortClick}
              */
            />
            {/* <Pagination
              currentPage={currentPage}
              totalPages={totalPages ?? 0}
              onPageChange={handlePageChange}
            /> */}
          </div>
        </Accordion>
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <SkeletonLoader />
        </div>
      )}
      <Modal
        isOpen={showResponse}
        closeModal={handleCloseModal}
        showCloseButton={true}
        width="w-[60%] h-[60vh]"
        modalHeader={PAP_NAMESPACES?.RESPONSE}
      >
        <div className="h-full max-h-[52vh] overflow-auto">
          <PapCaptureApiShowResponse
            row={JSON.stringify(modalParsedData?.responses)}
          />
        </div>
      </Modal>
    </>
  )
}

export default PapCaptureApiResponse
